import React from 'react';
import { DashboardTemplate } from './shared';
import { monetizationConfig, mockMonetizationData } from './configs/monetization-config';
import { mergeDataWithFallback } from '../../../utils/dataFallback';

function MonetizationData({ report = {}, loading = false }) {
    // Only use mock data when not loading (to avoid showing mock data before API response)
    const dataWithMock = loading ? report : mergeDataWithFallback(report, mockMonetizationData);
    
    return (
        <DashboardTemplate 
            title={monetizationConfig.title}
            topKPIs={monetizationConfig.topKPIs}
            charts={monetizationConfig.charts}
            bottomKPIs={monetizationConfig.bottomKPIs}
            report={dataWithMock}
            loading={loading}
        />
    );
}

export default MonetizationData;
